export default function Avis() {
  const garanties = [
    {
      icon: "ri-file-list-3-line",
      titre: "Devis ferme avant intervention",
      description:
        "Le prix annoncé est le prix payé. Pas de surprise, pas de frais cachés. Un devis écrit et détaillé vous est remis avant tout commencement de travaux.",
    },
    {
      icon: "ri-puzzle-line",
      titre: "Pièce comprise dans le prix",
      description:
        "Toutes nos interventions incluent la pièce de rechange et la main-d'\u0153uvre. Pas de supplément sur la pièce détachée, c'est intégré dans le tarif affiché.",
    },
    {
      icon: "ri-time-line",
      titre: "Intervention sous 24h",
      description:
        "Dépannage disponible 7j/7 sur Strasbourg et le Bas-Rhin. Un technicien se rend chez vous dans les 24 heures, souvent le jour même pour les urgences.",
    },
    {
      icon: "ri-shield-check-line",
      titre: "Toutes marques",
      description:
        "Somfy, Nice, Bubendorff, Profalux, Faac, Becker, ou volet sans marque : nous réparons et motorisons tous les volets roulants, quel que soit le fabricant.",
    },
  ];

  return (
    <section className="bg-white py-14 md:py-20" id="garanties">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-3">
            Nos garanties
          </h2>
          <p className="text-[#143A66]/70 text-base md:text-lg max-w-2xl mx-auto">
            Ce que vous obtenez en faisant appel à Dépan'Volets.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {garanties.map((g, i) => (
            <div
              key={i}
              className="bg-[#F7F9FA] rounded-xl border border-[#E5EBF0] p-5 md:p-6 flex flex-col"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#00B3A4]/10 mb-4">
                <i className={`${g.icon} text-[#00B3A4] text-xl`}></i>
              </div>
              <h3 className="text-[#143A66] font-semibold text-base mb-2">
                {g.titre}
              </h3>
              <p className="text-[#143A66]/70 text-sm leading-relaxed">
                {g.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}